export const settings = {
    "title": "TEDxConegliano",
    "description": "TEDxConegliano",
    "apiUrl": "localhost:3000/api",
    "ckdPath": "localhost:3000/"
}